import { useEffect } from "react";
import styles from "../../styles/__dialogReusableMd.module.scss";

export default function DialogReusableMd({
  open,
  onClose,
  children,
  className = ""
}) {
  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [open]);

  if (!open) return null;

  return (
    <div className={`${styles["dialog-overlay"]} ${className}`}>
      <div className={styles["dialog-box"]}>
        <button className={styles["dialog-close"]} onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5525 12.0002L17.8525 7.71019C18.0408 7.52188 18.1466 7.26649 18.1466 7.00019C18.1466 6.73388 18.0408 6.47849 17.8525 6.29019C17.6642 6.10188 17.4088 5.99609 17.1425 5.99609C16.8762 5.99609 16.6208 6.10188 16.4325 6.29019L12.1425 10.5902L7.85252 6.29019C7.66421 6.10188 7.40882 5.99609 7.14252 5.99609C6.87622 5.99609 6.62082 6.10188 6.43252 6.29019C6.24421 6.47849 6.13843 6.73388 6.13843 7.00019C6.13843 7.26649 6.24421 7.52188 6.43252 7.71019L10.7325 12.0002L6.43252 16.2902C6.33879 16.3831 6.26439 16.4937 6.21363 16.6156C6.16286 16.7375 6.13672 16.8682 6.13672 17.0002C6.13672 17.1322 6.16286 17.2629 6.21363 17.3848C6.26439 17.5066 6.33879 17.6172 6.43252 17.7102C6.52548 17.8039 6.63608 17.8783 6.75794 17.9291C6.8798 17.9798 7.01051 18.006 7.14252 18.006C7.27453 18.006 7.40523 17.9798 7.52709 17.9291C7.64895 17.8783 7.75955 17.8039 7.85252 17.7102L12.1425 13.4102L16.4325 17.7102C16.5255 17.8039 16.6361 17.8783 16.7579 17.9291C16.8798 17.9798 17.0105 18.006 17.1425 18.006C17.2745 18.006 17.4052 17.9798 17.5271 17.9291C17.649 17.8783 17.7596 17.8039 17.8525 17.7102C17.9462 17.6172 18.0206 17.5066 18.0714 17.3848C18.1222 17.2629 18.1483 17.1322 18.1483 17.0002C18.1483 16.8682 18.1222 16.7375 18.0714 16.6156C18.0206 16.4937 17.9462 16.3831 17.8525 16.2902L13.5525 12.0002Z" fill="currentcolor"/>
          </svg>
        </button>
        <div>{children}</div>
      </div>
    </div>
  );
}
